import React from 'react'

const RefundPolicy = () => {
  return (
       <div className=''>
      <div className="container">
        {/* Add logos here */}
        <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
          <img
            src="https://static.wixstatic.com/media/5715af_a286bfb446374a96877a4193a1ef0933~mv2.png"
            alt="PAT Logo"
            style={{ width: '120px', marginRight: '20px', verticalAlign: 'middle' }}
          />
          <img
            src="https://static.wixstatic.com/media/77a25b_ec2fa92086954799bf72699afde7a666~mv2.png"
            alt="VMKG Logo"
            style={{ width: '200px', verticalAlign: 'middle' }}
          />
        </div>

  <div
  className="card"
  style={{
    background: "#fff",
    borderRadius: "16px",
    padding: "40px",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto 40px",
    boxShadow: "0 6px 30px rgba(0,0,0,0.1)",
    fontSize: "16px",
    color: "#333",
    lineHeight: "1.7",
    textAlign: "left",
    overflowY: "auto",
    maxHeight: "100%",
    position: "relative"
  }}
>
  {/* Heading */}
  <h2
    style={{
      fontSize: "30px",
      fontWeight: "700",
      marginBottom: "20px",
      textAlign: "center",
      color: "#222"
    }}
  >
    Cancellation & Refund Policy
  </h2>

  {/* Full Content */}
  <p style={{ marginBottom: "20px", color: "#555", fontSize: "17px" }}>
    Thank you for choosing Personal Assessment Test. Please read our cancellation and refund policy carefully.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Cancellation Policy:</h3>
  <p>
    Once an assessment has been purchased and begun, it cannot be cancelled.
    <br />
    If you wish to cancel an assessment before beginning it, please contact our customer support team at{" "}
    <a href="mailto:reachus@victormanickam.com" style={{ color: "#396AA9", textDecoration: "none", fontWeight: "500" }}>
      reachus@victormanickam.com
    </a>{" "}
    as soon as possible.
    <br />
    We reserve the right to refuse any cancellation request at our discretion.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Refund Policy:</h3>
  <p>
    Personal Assessment Test operates on a strict no-refund policy. <br />
    Refunds will not be issued for partially or fully completed assessments.
    <br />
    Refunds will only be considered in the following circumstances:
  </p>
  <ul style={{ paddingLeft: "20px", color: "#555" }}>
    <li><strong>False transactions:</strong> If a transaction was not authorised by the account holder, we will investigate and issue a refund if the transaction is deemed fraudulent.</li>
    <li><strong>Duplicate transactions:</strong> If you accidentally purchased the same assessment multiple times, we will refund the duplicate transaction(s).</li>
  </ul>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>How to Request a Refund:</h3>
  <p>
    To request a refund due to false or duplicate transactions, please contact our customer support team at{" "}
    <a href="mailto:reachus@victormanickam.com" style={{ color: "#396AA9", textDecoration: "none", fontWeight: "500" }}>
      reachus@victormanickam.com
    </a>{" "}
    within 7 days of the transaction.
    <br />
    Provide details such as your order number, transaction ID, and any relevant information to assist us in processing your request promptly.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Contact Information:</h3>
  <p>
    For any questions, concerns, or refund requests, please contact our customer support team at{" "}
    <a href="mailto:reachus@victormanickam.com" style={{ color: "#396AA9", textDecoration: "none", fontWeight: "500" }}>
      reachus@victormanickam.com
    </a>.
    <br />
    Our team will strive to respond to your inquiries within 24-48 hours.
  </p>

  <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "20px" }}>Policy Acceptance:</h3>
  <p>
    By purchasing an assessment on Personal Assessment Test, you acknowledge and agree to the terms of our cancellation and refund policy.
  </p>

  <p style={{ marginTop: "20px", fontWeight: "500", color: "#444" }}>
    Please note that Personal Assessment Test reserves the right to update or modify this policy at any time without prior notice. 
    We recommend reviewing this policy periodically for any changes.
  </p>

  {/* Sticky footer button (optional) */}
  <div style={{
      position: "sticky",
      bottom: "0",
      background: "#fff",
      padding: "20px 0",
      textAlign: "center",
      borderTop: "1px solid #eee",
      marginTop: "20px"
    }}>
    {/* Uncomment if needed
    <button
      style={{
        background: "#396AA9",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        padding: "12px 28px",
        fontSize: "16px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "0.3s"
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#FEBD16")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "#396AA9")}
    >
      Accept & Proceed
    </button> 
    */}
  </div>
</div>


      </div>
    </div>
  )
}

export default RefundPolicy